import * as React from 'react';
import { useDeviceType } from '../../responsive';
export var InputSizeContext = /*#__PURE__*/React.createContext(null);

/**
 * Хук для получения размера в InputAdornment
 */
export function useInputSize(size) {
  var deviceType = useDeviceType();
  var contextSize = React.useContext(InputSizeContext);
  if (size) {
    return size;
  }
  if (contextSize) {
    return contextSize;
  }
  return deviceType === 'phone' ? 'M' : 'XS';
}